export default __webpack_public_path__ + "static/media/ic_boo_24.1cbae058.svg";